export default function getGradeName(value: any) {
  // if (value === '5') {
  //   return 'Omandasid täielikult';
  // }
  // if (value === '4') {
  //   return 'Omandasid peamise';
  // }
  // if (value === '3') {
  //   return 'Omandasid osaliselt';
  // }
  // if (value === '2') {
  //   return 'Omandamata';
  // }
  // if (value === '1') {
  //   return 'Omandamata';
  // }
  if (value === 'NaN') {
    return '-';
  }

  return value;
}
